<template>
  <div id="chart">
    <!-- <div class="toolbar">
            <button
                id="one_month"
                @click="updateData('one_month')"
                :class="{ active: selection === 'one_month' }"
            >
                1M
            </button>

            <button
                id="six_months"
                @click="updateData('six_months')"
                :class="{ active: selection === 'six_months' }"
            >
                6M
            </button>

            <button
                id="one_year"
                @click="updateData('one_year')"
                :class="{ active: selection === 'one_year' }"
            >
                1Y
            </button>

            <button id="ytd" @click="updateData('ytd')" :class="{ active: selection === 'ytd' }">
                YTD
            </button>

            <button id="all" @click="updateData('all')" :class="{ active: selection === 'all' }">
                ALL
            </button>
        </div> -->

    <div id="chart-timeline">
      <apexchart
        type="area"
        height="210"
        ref="chart"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
// import VueApexCharts from "vue3-apexcharts";
import axios from "axios";

export default {
  props: ["chartData"],
  data() {
    return {
      series: [
        {
          name: "",
          data: [],
        },
      ],
      chartOptions: {
        colors: ["#369DA3"],
        chart: {
          id: "area-datetime",
          type: "area",
          height: 350,
          zoom: {
            autoScaleYaxis: false,
          },
        },
        annotations: {
          // yaxis: [
          //     {
          //         y: 30,
          //         borderColor: "#999",
          //         label: {
          //             show: true,
          //             text: "Support",
          //             style: {
          //                 color: "#fff",
          //                 background: "#00E396",
          //             },
          //         },
          //     },
          // ],
          // xaxis: [
          //     {
          //         x: new Date("14 Nov 2020").getTime(),
          //         borderColor: "#999",
          //         yAxisIndex: 0,
          //         label: {
          //             show: true,
          //             text: "Rally",
          //             style: {
          //                 color: "#fff",
          //                 background: "#775DD0",
          //             },
          //         },
          //     },
          // ],
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        xaxis: {
          type: "datetime",
          min: new Date("10 dec 2023").getTime(),
          tickAmount: 6,
          labels: {
            style: { fontSize: "14px", fontWeight: 600 },
          },
        },
        yaxis: {
          labels: {
            formatter: function (val, index) {
              return val.toLocaleString();
            },
            style: { fontSize: "14px", fontWeight: 600 },
          },
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
      },

      selection: "one_year",
      charts: [],
    };
  },
  methods: {
    updateData: function (timeline) {
      this.selection = timeline;

      switch (timeline) {
        case "one_month":
          this.$refs.chart.zoomX(
            new Date("28 Jan 2020").getTime(),
            new Date("27 Feb 2020").getTime()
          );
          break;
        case "six_months":
          this.$refs.chart.zoomX(
            new Date("27 Sep 2020").getTime(),
            new Date("27 Feb 2020").getTime()
          );
          break;
        case "one_year":
          this.$refs.chart.zoomX(
            new Date("27 Feb 2020").getTime(),
            new Date("27 Feb 2020").getTime()
          );
          break;
        case "ytd":
          this.$refs.chart.zoomX(
            new Date("01 Jan 2020").getTime(),
            new Date("27 Feb 2020").getTime()
          );
          break;
        case "all":
          this.$refs.chart.zoomX(
            new Date("23 Jan 2019").getTime(),
            new Date("27 Feb 2020").getTime()
          );
          break;
        default:
      }
    },
  },
  mounted() {
    this.getHeatmap();
  },
  methods: {
    async getHeatmap() {
      await axios
        .get("https://publish.dkilo.com/api/heatmap", {
          headers: {
            token: localStorage.getItem("token"),
            "Country-code": localStorage.getItem("country_code"),
          },
        })
        .then((response) => {
          this.charts = [];
          this.charts = response.data.chart;
          this.series[0].data = Object.values(this.charts).map((el) => {
            if (localStorage.getItem("country_code") === "SA") {
              return [el.date, el.modulated_ble_impressions];
            } else if (localStorage.getItem("country_code") === "EG") {
              return [el.date, el.modulated_impressions];
            }
            // return [el.date, el.modulated_impressions];
          });
          // console.log(this.series[0].data);
        });
    },
  },
};
</script>

<style>
.apexcharts-tooltip-title {
  background: #369da3 !important;
  color: white;
  margin: 0px !important ;
}
.apexcharts-tooltip-series-group {
  background: #f3f3f3 !important;
  padding-bottom: 5px !important;
  padding-top: 5px !important;
}
</style>
